import {TypeNatureMarcheChoix} from './TypeNatureMarcheChoix';
import {TypeObjCPV} from './TypeObjCPV';
import {TypeOuiNonReservationMarche} from './TypeOuiNonReservationMarche';
import {TypeOuiNon} from './TypeOuiNon';
import { TypeMontantFourchette2 } from './TypeMontantFourchette2';
export class TypeFNSSimpleDescMarche {

	public reservationMarche: TypeOuiNonReservationMarche;

	public lieuExecution: string;

	public dureeMois: number;

	public description: string;

	public valeurEstimee: TypeMontantFourchette2;

	public intitule: string;

	public natureMarche: TypeNatureMarcheChoix;

	public codeCPV: TypeObjCPV;

	public tranches: TypeOuiNon;

	public lotsMarche: TypeOuiNon;

	constructor() {
		this.reservationMarche = new TypeOuiNonReservationMarche();
		this.lieuExecution = '';
		this.dureeMois = 0;
		this.description = '';
		this.valeurEstimee = new TypeMontantFourchette2();
		this.intitule = '';
		this.natureMarche = new TypeNatureMarcheChoix();
		this.codeCPV = new TypeObjCPV();
		this.tranches = new TypeOuiNon();
		this.lotsMarche = new TypeOuiNon();
	}
}
